// src/pages/Users/Inscription/components/SelectedGroupCard.jsx

import React from "react";

import {
  FaCheckCircle,
  FaClock,
  FaInfoCircle,
  FaMapMarkerAlt,
  FaTimes,
} from "react-icons/fa";

import {
  formatEuro,
  getColorMeta,
  getGroupSchedules,
} from "../utils/inscriptionUtils";

export default function SelectedGroupCard({
  group,
  dojo,
  onRemove,
  onOpenDetails,
}) {
  const color = getColorMeta(group.color_groupe);
  const schedules = getGroupSchedules(group);

  const total =
    Number(group.tarif_licence || 0) +
    Number(group.tarif_cotisation || 0);

  return (
    <article
      className={`relative overflow-hidden rounded-[1.7rem] border ${color.border} bg-white shadow-sm dark:bg-slate-900`}
    >
      <div className={`absolute inset-y-0 left-0 w-2 ${color.solid}`} />

      <div className="p-4 pl-6">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <div className="inline-flex items-center gap-1.5 rounded-full bg-emerald-100 px-2.5 py-1 text-[10px] font-black uppercase tracking-wide text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300">
              <FaCheckCircle />
              Groupe sélectionné
            </div>

            <h3 className="mt-2 text-lg font-black text-slate-950 dark:text-white">
              {group.nom || "Groupe"}
            </h3>

            <div className="mt-2 flex flex-wrap gap-2">
              {group.discipline_groupe ? (
                <span
                  className={`rounded-full px-2.5 py-1 text-xs font-bold ${color.light} ${color.text}`}
                >
                  {group.discipline_groupe}
                </span>
              ) : null}

              <span className="inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-2.5 py-1 text-xs font-bold text-slate-600 dark:bg-slate-800 dark:text-slate-300">
                <FaMapMarkerAlt className="text-[10px]" />
                {dojo?.dojo_nom || "Lieu non renseigné"}
              </span>
            </div>
          </div>

          <button
            type="button"
            onClick={onRemove}
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl border border-rose-200 bg-rose-50 text-rose-600 transition hover:bg-rose-100 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300"
            title="Retirer ce groupe"
          >
            <FaTimes />
          </button>
        </div>

        {/* Horaires */}

        {schedules.length > 0 ? (
          <div className="mt-3 flex flex-wrap items-center gap-2">
            <FaClock className="text-xs text-slate-400" />

            {schedules.slice(0, 2).map((schedule, index) => (
              <span
                key={`${schedule}-${index}`}
                className="rounded-xl bg-slate-100 px-2.5 py-1 text-xs font-bold text-slate-600 dark:bg-slate-800 dark:text-slate-300"
              >
                {schedule}
              </span>
            ))}

            {schedules.length > 2 ? (
              <span className="text-xs font-bold text-slate-400">
                +{schedules.length - 2}
              </span>
            ) : null}
          </div>
        ) : null}

        {/* Footer */}

        <div className="mt-4 flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 pt-3 dark:border-slate-800">
          <div>
            <p className="text-[10px] font-bold uppercase tracking-wide text-slate-400">
              Tarif total
            </p>

            <p className="mt-0.5 font-black text-emerald-600 dark:text-emerald-300">
              {formatEuro(total)}
            </p>
          </div>

          <button
            type="button"
            onClick={onOpenDetails}
            className="inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-xs font-bold text-slate-600 transition hover:border-indigo-200 hover:bg-indigo-50 hover:text-indigo-700 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-300 dark:hover:bg-indigo-500/10 dark:hover:text-indigo-300"
          >
            <FaInfoCircle />
            Voir la fiche
          </button>
        </div>
      </div>
    </article>
  );
}